import React, { useEffect, useState } from 'react';
import './NavigationIndicator.css';

export type IndicatorType = 'play' | 'pause' | 'forward' | 'backward' | null;

interface NavigationIndicatorProps {
  type: IndicatorType;
  onComplete?: () => void;
}

const NavigationIndicator: React.FC<NavigationIndicatorProps> = ({ type, onComplete }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (type) {
      setVisible(true);
      const timer = setTimeout(() => {
        if (onComplete) {
          onComplete();
        }
      }, 400); // Animation duration
      
      return () => clearTimeout(timer);
    } else {
      setVisible(false);
    }
  }, [type, onComplete]);

  if (!type) return null;

  const getIcon = () => {
    switch (type) {
      case 'play':
        return (
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
            <circle cx="40" cy="40" r="38" fill="rgba(0, 0, 0, 0.75)" />
            <path d="M30 25l25 15-25 15z" fill="white" />
          </svg>
        );
      case 'pause':
        return (
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
            <circle cx="40" cy="40" r="38" fill="rgba(0, 0, 0, 0.75)" />
            <rect x="28" y="25" width="10" height="30" fill="white" />
            <rect x="42" y="25" width="10" height="30" fill="white" />
          </svg>
        );
      case 'forward':
        return (
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
            <circle cx="40" cy="40" r="38" fill="rgba(0, 0, 0, 0.75)" />
            <path d="M28 28l16 12-16 12z" fill="white" />
            <path d="M38 28l16 12-16 12z" fill="white" />
          </svg>
        );
      case 'backward':
        return (
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
            <circle cx="40" cy="40" r="38" fill="rgba(0, 0, 0, 0.75)" />
            <path d="M52 28l-16 12 16 12z" fill="white" />
            <path d="M42 28l-16 12 16 12z" fill="white" />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div 
      className={`navigation-indicator ${type} ${visible ? 'visible' : ''}`}
    >
      {getIcon()}
    </div>
  );
};

export default NavigationIndicator;